import * as dateFilters from "./date-filters";

const filters =
{
    ...dateFilters
};

export default filters;
